import type { ColDef } from 'ag-grid-community';
import { formatBytes } from '../utilities/format';

/**
 * Default tabular grid-view columns for the resource grid — ported from Angular's
 * PreferenceService.DEFAULT_GRID_COLUMNS (order, headerName, field, colId,
 * and the filter:false flags). colId defaults to field when omitted, exactly as Angular
 * keyed on `colId ?? field`. Size/Page Count get value formatters (Angular used cell
 * templates). Sortable + resizable come from IioDataGrid's defaultColDef; per-column
 * text filters are enabled in M3e-2. Saved column state (order/hide/pin/width, in
 * localStorage) overrides this default at runtime.
 */
export const RESOURCE_GRID_COLUMNS: ColDef[] = [
  { headerName: 'Sort Key', field: 'sortKey', colId: 'sortKey', filter: false },
  { headerName: 'Folio Identifier', field: 'id', colId: 'resourceId', filter: false },
  { headerName: 'Title', field: 'title', colId: 'title', filter: false },
  { headerName: 'Path', field: 'path', colId: 'path' },
  { headerName: 'Folder', field: 'folders', colId: 'folders' },
  { headerName: 'Created Date', field: 'createdDate', colId: 'createdDate', filter: false },
  { headerName: 'Modified Date', field: 'modifiedDate', colId: 'modifiedDate', filter: false },
  { headerName: 'From', field: 'emailFrom', colId: 'emailFrom' },
  { headerName: 'To', field: 'emailTo', colId: 'emailTo' },
  { headerName: 'CC', field: 'emailCc', colId: 'emailCc' },
  { headerName: 'BCC', field: 'emailBcc', colId: 'emailBcc' },
  { headerName: 'Conversation Topic', field: 'emailConversationTopic', colId: 'emailConversationTopic' },
  { headerName: 'Name', field: 'filename', colId: 'fileName' },
  { headerName: 'Creator', field: 'creator', colId: 'creator' },
  {
    headerName: 'Size (MB)', field: 'bytes', colId: 'fileSize', filter: false,
    valueFormatter: (p) => (p.value == null ? '' : formatBytes(p.value as number)),
  },
  {
    headerName: 'Page Count', field: 'numPdfPages', colId: 'pageCount', filter: false,
    valueFormatter: (p) => (p.value == null ? '' : Number(p.value).toLocaleString()),
  },
  { headerName: 'File Extension', field: 'extension', colId: 'fileExtension' },
  { headerName: 'File Category', field: 'category', colId: 'category' },
  { headerName: 'Record Type', field: 'type', colId: 'type' },
  { headerName: 'Is Top Parent', field: 'isTopParent', colId: 'isTopParentResource' },
  { headerName: 'Is Container', field: 'isContainer', colId: 'isContainer' },
  { headerName: 'Is Source Storage', field: 'isSourceStorage', colId: 'isSourceStorage' },
  { headerName: 'Has Notes', field: 'hasNotes', colId: 'hasNotes' },
  { headerName: 'Has Privileged Notes', field: 'hasPrivilegedNotes', colId: 'hasPrivilegedNotes' },
  { headerName: 'Mime Type', field: 'mimeType', colId: 'mimeType' },
  { headerName: 'MD5', field: 'md5', colId: 'md5' },
  { headerName: 'Beg Bates', field: 'lastBegBates', colId: 'lastBegBates' },
  { headerName: 'End Bates', field: 'lastEndBates', colId: 'lastEndBates' },
  { headerName: 'Beg Attach Bates', field: 'lastBegAttachBates', colId: 'lastBegAttachBates' },
  { headerName: 'End Attach Bates', field: 'lastEndAttachBates', colId: 'lastEndAttachBates' },
];
